module.exports = __webpack_public_path__ + "img/img_target_top_bf.ef3f87e6.svg";